(function () {
    'use strict';

    angular
            .module('imnApp')
            .filter('patternMeter', patternMeter);

    patternMeter.$inject = ['$filter'];
    function patternMeter($filter) {
        return patterMeterFilter;

        function patterMeterFilter(distance) {

            if (!distance) {
                return '-- m';
            }

            var distanceValid = parseInt(distance);
            var result = null;

            if (distanceValid > 0) {
                result = parseFloat(distance).toFixed(1) + ' km';
            } else {
                result = (distance * 1000).toFixed(1) + ' m';
            }
            result = result.replace('.', ',');

            return result;
        }
    }
})();


